import React from "react";
import { makeStyles } from "@material-ui/core";

const useIconStyles = makeStyles({
  root: {
    display: "flex",
    width: 16,
    height: 16,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
    fontSize: 12,
    backgroundColor: "#d7d7d7",
    color: "#999",
  },
  active: { backgroundColor: "#e70017", color: "#fff" },
});

function StepIcon({ active, completed, icon }) {
  const classes = useIconStyles();
  return (
    <div className={`${classes.root} ${active || completed ? classes.active : ""}`}>
      {icon}
    </div>
  );
}

export default StepIcon;
